<template>
  <div class="step bg-white w-100">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Step'
}
</script>

<style lang="scss" scoped>
  @use '../assets/scss/variables' as *;
  @use '../assets/scss/media-queries' as *;

  .step {
    box-shadow: 0 10px 50px 0 rgba(47,59,80,0.1);
    padding: 60px 80px;
    border-top: 1px solid $grey-1;
    border-bottom: 1px solid $grey-1;

    @include max-screen(991px) {
      padding: 30px;
    }
  }
</style>
